import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05a4d358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sdds-col-md-12" }
const _hoisted_2 = { class: "sdds-table sdds-table--compact sdds-table--divider sdds-table-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "sdds-table__header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sdds-table__row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Template Field"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "File Field")
  ])
], -1))
const _hoisted_4 = { class: "sdds-table__body" }
const _hoisted_5 = { class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2 sdds-center" }
const _hoisted_6 = ["onClick", "data-test-id"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2" }
const _hoisted_9 = { class: "component-wrapper" }
const _hoisted_10 = { class: "sdds-modal modal-add-fields" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-modal-headline" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Details")
], -1))
const _hoisted_12 = { class: "sdds-modal-body" }

import { PropType, ref, watch } from 'vue';
import info from '../assets/info.svg';
import { SelectionEvent } from '../types/event';
import { FieldMap, FieldValue, OptionDrop } from '../types/types';
import SddsDropdown from './common/BaseSddsDropdown.vue';
import SddsMessage from './common/SddsMessage.vue';
import HelpInfo from './FileImporterHelpDoc.vue';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FieldImporterMapper',
  props: {
  fieldsTemplate: {
    type: Array as PropType<Array<FieldMap>>,
    required: true,
  },
  fieldsField: {
    type: Array as PropType<Array<OptionDrop>>,
    required: true,
  },
  defaultFields: {
    type: Array as PropType<Array<FieldValue>>,
  },
  keyUseDefaultFields: {
    type: Number,
  },
},
  emits: ['template:validation'],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line


const fieldsTemplateInUse = ref([]);
const modalHelpInfo = ref(null);
const showInfoMessage = ref(null);

let templateData = {};
const temp = {};
props.fieldsTemplate.forEach((item) => {
  temp[item.field] = JSON.parse(JSON.stringify(item));
  temp[item.field].fieldReference = ref(null);
  fieldsTemplateInUse.value.push(temp[item.field]);
});
templateData = temp;

const getFieldTemplateData = (fieldId) => templateData[fieldId].fieldReference.value;

const checkTemplate = () => {
  console.log('checkTemplate');
  let valid = true;
  props.fieldsTemplate.forEach((item) => {
    const element = templateData[item.field];
    if (element.required && element.fieldReference.value == null) {
      valid = false;
    }
  });
  const templateMapper = {};
  if (valid) {
    Object.entries(templateData).forEach(([key, item]: any) => {
      templateMapper[key] = JSON.parse(JSON.stringify(item));
      delete templateMapper[key].fieldReference;
      delete templateMapper[key].info;
      templateMapper[key].field = item.fieldReference.value ?? null;
      if (templateMapper[key].field === null) {
        delete templateMapper[key];
      }
    });
  }
  console.log('templateMapper: ', templateMapper);
  emit('template:validation', { valid, template: templateMapper });
};

const handleUpdateSelectionField = (selection: SelectionEvent) => {
  console.log('handleUpdateSelection: ', selection);
  if (selection.keyDropdown) {
    templateData[selection.keyDropdown].fieldReference.value = selection.value;
  }
  validateDuplicates();
  checkTemplate();
};

const showHelpModal = (fieldId) => {
  console.log('showHelpModal: ', fieldId);
  modalHelpInfo.value = fieldId;
};

const closeModalHelp = () => {
  console.log('closeModalHelp');
  modalHelpInfo.value = null;
};

const validateDuplicates = () =>{
  let duplicates = false;
  const usedOptions = [];
  Object.entries(templateData).forEach(([key, item]: any) => {
    if (item.fieldReference.value) {
      if (usedOptions.includes(item.fieldReference.value)) {
        console.log('duplicate mapping: ', key);
        duplicates = true;
      }
      usedOptions.push(item.fieldReference.value);
    }
  });
  showInfoMessage.value = duplicates;
}

const validateDefaults = () => {
  props.defaultFields.forEach((v) => {
    if (props.fieldsField.some(i => i.key === v.value)) templateData[v.field].fieldReference.value = v.value
  })
  validateDuplicates();
  checkTemplate();
}

watch(() => props.keyUseDefaultFields, (selection, prevSelection) => {
  console.log('watch-props.useDefaultFields', selection, prevSelection)
  if (selection) validateDefaults()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (showInfoMessage.value)
        ? (_openBlock(), _createBlock(SddsMessage, {
            key: 0,
            type: "info",
            "header-message": " Duplicate Mapping Value",
            "body-message": "There are Template Fields with the same File Field value"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldsTemplateInUse.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "sdds-table__row",
              key: index,
              "data-test-id": "fields"
            }, [
              _createElementVNode("td", _hoisted_5, [
                _createTextVNode(_toDisplayString(item.description ?? item.field) + " ", 1),
                (item.help)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: ($event: any) => (showHelpModal(item.field)),
                      "data-test-id": 'btH_' + item.field
                    }, [
                      _createElementVNode("img", {
                        class: "img-add-temp-add",
                        src: _unref(info)
                      }, null, 8, _hoisted_7)
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createVNode(SddsDropdown, {
                    size: "small",
                    "id-drop": item.field,
                    selection: getFieldTemplateData(item.field),
                    includeDeselect: true,
                    options: __props.fieldsField,
                    required: item.required,
                    "onUpdate:selection": handleUpdateSelectionField
                  }, null, 8, ["id-drop", "selection", "options", "required"])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: _normalizeClass(["sdds-modal-backdrop", [modalHelpInfo.value ? 'show' : 'hide']])
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", { class: "sdds-modal-header" }, [
            _hoisted_11,
            _createElementVNode("span", {
              class: "sdds-modal-btn",
              onClick: closeModalHelp
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(HelpInfo, {
              "id-drop": modalHelpInfo.value,
              "data-test-id": "helpInfo"
            }, null, 8, ["id-drop"])
          ]),
          _createElementVNode("div", { class: "sdds-modal-actions" }, [
            _createElementVNode("div", { class: "sdds-modal-actions" }, [
              _createElementVNode("button", {
                class: "sdds-btn sdds-btn-primary sdds-btn-md",
                onClick: closeModalHelp
              }, "Close")
            ])
          ])
        ])
      ], 2)
    ])
  ], 64))
}
}

})